const single_sign_on = {
    forbidden_domains: 'Domínios de e-mail público não são permitidos.',
    duplicated_domains: 'Existem domínios duplicados.',
    /** UNTRANSLATED */
    invalid_domain_format: 'Invalid domain format.',
    /** UNTRANSLATED */
    duplicate_connector_name: 'Connector name already exists. Please choose a different name.',
};
export default Object.freeze(single_sign_on);
